import React from "react";

interface IForbiddenAccessProps {
  message?: React.ReactNode;
}

const DEFAULT_MESSAGE = "You do not have access to this resource.";

export const ForbiddenAccess: React.FC<IForbiddenAccessProps> = ({
  message = DEFAULT_MESSAGE,
}) => {
  return (
    <div className="w-full h-screen place-items-center grid">
      <div className="grid text-center">
        <span className="text-3xl">403</span>
        <span className="text-xl">Forbidden</span>
        <span className="text-red-500">{message}</span>
      </div>
    </div>
  );
};

export default ForbiddenAccess;
